import {useEffect, useState} from 'react';
import {Grid} from '@mui/material';
import {useStylesBorder} from '../../utils/styles/styles';
import {LineBarMultiAxisChar} from '../components/LineBarMultiAxisChart';
import {useEstadisticasCRM} from '../hooks/useEstadisticasCRM';
import {mapperEstadoProductoToDataMultiChar} from '../../utils/mappers/mapperEstadoProductoToDataMultiChar';
import {EstadoProductosAnual} from '../../bussines/entities/EstadisticasCRM.entity';
import {dataMultiAxisChart} from '../../utils/types/multiAxisChart';
interface LlavesChartProps {
   fecha: Date;
}

export const ProductosPorEstado: React.FC<LlavesChartProps> = ({fecha}) => {
   const {classes} = useStylesBorder();
   const [dataMultiChart, setDataMultiChart] = useState<dataMultiAxisChart[]>([]);
   const [dataResumenEstado, setDataResumenEstado] = useState<EstadoProductosAnual[]>([]);
   const {getProductosEstadoAnual} = useEstadisticasCRM();
   const fetchProductosEstado = async () => {
      const result = await getProductosEstadoAnual({fecha: fecha});
      if (result) {
         setDataResumenEstado(result);
      }
   };
   useEffect(() => {
      fetchProductosEstado();
   }, []);
   useEffect(() => {
      if (dataResumenEstado) {
         const newData = mapperEstadoProductoToDataMultiChar({
            data: dataResumenEstado
         });
         setDataMultiChart(newData);
      }
   }, [dataResumenEstado]);
   return (
      <Grid container className={classes.border}>
         <LineBarMultiAxisChar
            title={'Productos por Estado'}
            data={dataMultiChart}
            categories={{
               nuevo: {
                  label: 'Nuevos',
                  borderColor: 'rgba(54, 162, 235, 1)',
                  backgroundColor: 'rgba(54, 162, 235, 0.2)'
               },
               activo: {
                  label: 'Activos',
                  borderColor: 'rgba(75, 192, 192, 1)',
                  backgroundColor: 'rgba(75, 192, 192, 0.2)'
               },
               inactivo: {
                  label: 'Inactivos',
                  borderColor: 'rgba(255, 99, 132, 1)',
                  backgroundColor: 'rgba(255, 99, 132, 0.2)'
               }
            }}
            defaultSlider={{end: fecha.getMonth(), start: 0}}
         />
      </Grid>
   );
};
